import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import Grid from '@mui/material/Grid';
import { PageHeader } from 'components/ui/Global/PageHeader';
import { useTranslation } from 'react-i18next';
import { Outlet, useParams } from 'react-router-dom';
import { CompanyHeaderButtonDetails } from './Components/CompanyStyleConfig';

export const Company = () => {
  const { t } = useTranslation();

  /* INITIALIZATIONS */
  const { companyId } = useParams(); // check if companyId is valid?

  // api

  if (companyId === undefined) {
    return null;
  }

  const CompanyHeaderLinks = CompanyHeaderButtonDetails(companyId, null);

  /* FUNCTIONS */

  return (
    <Grid container direction='row' spacing={0}>
      <Grid item xs={12} sx={{}}>
        <PageHeader
          Icon={BusinessRoundedIcon}
          title={t('company.header')}
          FormJSX={null}
          HeaderButtons={CompanyHeaderLinks}
        />
      </Grid>
      <Grid item xs={12} sx={{}}>
        <Outlet />
      </Grid>
    </Grid>
  );
};
